<!-- ake第三方车场接入指南 -->
<template>
    <div class="content">
        <ul>
            <li>
                <h2 class="title">接入指南</h2>
           </li>
        </ul>
        <ul>
            <li>
                <h3>什么是第三方车场接入</h3>
                <div>
                    第三方车场接入是指第三方自有停车场管理系统通过智慧停车开放平台一系列接口对接后,使第三方停车场管理系统具备云的能力，还可以跟云停车场相关产品进行打通，方便快捷地实现云上的数据存储、计算以及智能分析。
                </div>
                <div class="">
                    <img src="/static/img/thirdParking-1.png"/>
                </div>
            </li>
        </ul>

        <ul>
            <li>
                <h3>获取接入权限</h3>
                <div>
                   如您第一次使用智慧停车开放平台，请先联系智慧停车客服电话400-682-3828，我们会安排专业人员跟您对接确认需求。
                </div>
            </li>
        </ul>

        <ul>
            <li>
                <h3>对接方式</h3>
                <div>智慧停车开放平台提供了两种对接方，请选择合适的方式进行对接</div>
                <br/>
                <h4>SDK对接(TCP长连接)</h4>
                <div class="retract">说明:SDK实现与开放平台的长连接，认证、心跳等；第三方车场系统实现相关接口，完成对接。</div>
                <div class="retract">适用场景:第三方停车管理系统没有固定对外地址，不具备外网访问能力。</div>
                <div class="retract">对接文档:请查看SDK开发手册，如：<a class="link" target="_blank" href="/ApiForThirdPark/javaSdk">Java SDK开发手册</a></div>
                 <div class="">
                    <img src="/static/img/thirdParking-2.png"/>
                </div>
                <br/>
                <h4>HTTP方式：</h4>
                <div class="retract">说明:开放平台提供了相关接口的http请求方式，同时第三方车场管理系统应实现开放平台的</div>
                <div class="retract">适用场景:第三方停车管理系统有固定对外地址或者拥有自有云上平台，具备外网访问能力</div>
                <div class="retract">对接文档:对接方式、签名信息与平台接口一致，请查看：<a class="link" target="_blank" href="/Api/guide">HTTP对接指南</a></div>
                <div class="">
                    <img src="/static/img/thirdParking-3.png"/>
                </div>
                <br/>
            </li>
        </ul>

    </div>
</template>

<script>
export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            respTable: [
                { info1: 'status', info2: '是', info3: 'int', info4: '状态码',info5:'1业务成功,2业务失败,3系统异常,4签名错误,5key错误,6未授权,7请求参数不完整' },
                { info1: 'resultCode', info2: '是', info3: 'int', info4: '业务码',info5:'只有状态码为2时才生效，状态码不为2时业务结果为0;901-系统发生异常,902-远程服务器未响应,903-运营商不存在,904-停车场不存在,905-未找到在场车辆,906-账单不存在,907-账单已同步,908-其它错误'},
                { info1: 'message', info2: '是', info3: 'String', info4: '结果描述' },
                { info1: 'data', info2: '是', info3: 'JSONObject', info4: '返回数据' }
            ],
            othersData: [],
            explainWidth: 200,
        }
    },
}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    color: #1f2d3d;
    h3 {
        margin: 0;
        margin-bottom: 20px;
        font-size: 20px;
        color: #666666;
        letter-spacing: 0;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-bottom-color:#e5e5e5;
    }
    h4 {
        margin-bottom: 5px;
        font-size: 16px;
        color: #1b75bb;
    }
    a {
        font-size: 13px;
         color: #337ab7;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
    }
    .retract {
        padding-left: 15px;
    }
    .link {
        color: #10abe9;
    }

    pre {
        background-color: #f6f6f6;
        font-size: 12px;
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}

.ShaShiDi{
width:800px;
height:400px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi img{
    width:100%;
    height:auto;
}

.ShaShiDi2{
width:700px;
height:500px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi2 img{
    width:100%;
    height:auto;
}

.ShaShiDi3{
width:800px;
height:660px;
display:flex;
align-items:center;
justify-content:center;
}

.ShaShiDi3 img{
    width:100%;
    height:auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/guideForThirdPark.vue